import {
  ADDEDTOCART,
  DECREASEFROMCART,
  INCREASEFROMCART,
  REMOVECART,
} from './actionTypes';

export const addedToCart = (product) => {
  return {
    type: ADDEDTOCART,
    payload: product,
  };
};

export const increaseFromCart = (id) => {
  return {
    type: INCREASEFROMCART,
    payload: id,
  };
};

export const decreaseFromCart = (id) => {
  return {
    type: DECREASEFROMCART,
    payload: id,
  };
};

export const removeCart = (id) => {
  return {
    type: REMOVECART,
    payload: id,
  };
};
